import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Theme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useRegistration } from 'hooks';
import { LeftSideType, RegisterLayout, Spinner } from 'components';
import { CreateRoomForm, LeftPromocodeContainer, RegisterForm, SelectPlanForm } from './components';
import { IRegistrationContext } from 'context';

import styles from './RegisterPage.module.scss';

export function RegisterPage() {
  const { t } = useTranslation('auth');
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const { loading, stage, isCoupon, setCoupon }: IRegistrationContext = useRegistration();

  const { search } = useLocation();
  const promocode: string | null = new URLSearchParams(search).get('promocode');

  const headers: string[] = useMemo(() => {
    return isCoupon
      ? [t('registerHeaderProfile'), t('registerHeaderCreateRoom'), t('registerHeaderRedeemOffer')]
      : [t('registerHeaderProfile'), t('registerHeaderCreateRoom'), t('registerHeaderGetStarted')];
  }, [isCoupon, t]);

  const leftSideType: LeftSideType = useMemo(() => {
    if (isCoupon && stage === 1) {
      return 'promo';
    }
    return '30DaysFree';
  }, [isCoupon, stage]);

  const hideLeftSide: boolean = useMemo(() => {
    return isMobile && stage !== 1;
  }, [isMobile, stage]);

  useEffect(() => {
    if (promocode) {
      setCoupon(promocode);
    }
  }, [promocode, setCoupon]); // ✅ Ensure this runs when promocode changes.

  return (
    <RegisterLayout
      leftSideType={leftSideType}
      headers={headers}
      selectedHeader={stage}
      leftSide={!hideLeftSide ? isCoupon ? <LeftPromocodeContainer /> : null : null} // ✅ Fix mobile leftSide issue
    >
      <div className={styles.registerContainer}>
        {loading && <Spinner small />}
        {stage === 1 && <RegisterForm />}
        {stage === 2 && <CreateRoomForm />}
        {stage === 3 && <SelectPlanForm />}
      </div>
    </RegisterLayout>
  );
}
